import { useRef } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import { resolveHomepageImage } from '../../../helpers/homepageUtils';
import useTabsLayout from './useTabsLayout';
import TabContent from './TabContent';

const TabsBody = ({ data, blockId = 'tabs', path, metadata, className }) => {
  const groupRef = useRef(null);
  const tabs = data?.tabs || [];
  const variant = data?.variant || 'text';
  const sectionHeading = data?.section_heading;

  useTabsLayout(groupRef);

  if (!tabs.length) {
    return null;
  }

  const groupName = `tab-group-${blockId}`;

  return (
    <div className={className}>
      {sectionHeading ? <h3>{sectionHeading}</h3> : null}
      <form
        ref={groupRef}
        className={cx('tabs-group', `tabs-variant-${variant}`)}
      >
        {tabs.map((tab, index) => {
          const inputId = `tab-input-${blockId}-${index}`;
          const iconSrc = resolveHomepageImage(tab.icon);

          return (
            <div
              className={cx('tab', { 'with-image': variant === 'image' })}
              key={`${tab.title || 'tab'}-${index}`}
            >
              <input
                type="radio"
                id={inputId}
                name={groupName}
                defaultChecked={index === 0}
              />
              <label
                className={cx('tab-heading', {
                  'with-icon': variant === 'icon',
                })}
                htmlFor={inputId}
              >
                {variant === 'icon' && iconSrc ? (
                  <img src={iconSrc} alt="" className="tab-icon" />
                ) : null}
                {variant === 'image' && iconSrc ? (
                  <img src={iconSrc} alt="" className="tab-image" />
                ) : null}
                <span className="tab-title">{tab.title}</span>
              </label>
              <div className="icon-down-container">
                <img
                  className="tab-icon-down"
                  src="/angle-arrow-pointing-down.svg"
                  alt=""
                />
              </div>
              <div className="tab-content">
                <TabContent tab={tab} path={path} metadata={metadata} />
              </div>
            </div>
          );
        })}
      </form>
    </div>
  );
};

TabsBody.propTypes = {
  data: PropTypes.objectOf(PropTypes.any).isRequired,
  blockId: PropTypes.string,
  path: PropTypes.string,
  metadata: PropTypes.objectOf(PropTypes.any),
  className: PropTypes.string,
};

export default TabsBody;
